(function () {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initScrollReveal() {
    const main = document.querySelector('#MainContent');
    if (main) {
      main.querySelectorAll('.shopify-section').forEach((section, index) => {
        if (index === 0) return;
        const target = section.querySelector('.section, .media-with-content');
        if (target) target.classList.add('ozevia-reveal');
      });
    }

    if (prefersReducedMotion) {
      document.querySelectorAll('.ozevia-reveal').forEach((el) => el.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('.ozevia-reveal').forEach((el) => observer.observe(el));
  }

  function initHeroParallax() {
    if (prefersReducedMotion) return;

    const hero = document.querySelector('.hero-wrapper');
    if (!hero) return;

    const media = hero.querySelectorAll('.hero__media-wrapper, .hero__media');
    if (!media.length) return;

    let ticking = false;

    function updateParallax() {
      const scrollY = window.scrollY;
      const heroHeight = hero.offsetHeight;
      if (scrollY > heroHeight) return;

      const offset = scrollY * 0.18;
      media.forEach((el) => {
        el.style.transform = `translate3d(0, ${offset}px, 0)`;
      });
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  function init() {
    initScrollReveal();
    initHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
